import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCxlT0VdJM_xf2tzwHu0qnj2idJUN8Qc-c",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "majani-insurance-agent-dashbo.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "majani-insurance-agent-dashbo",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "majani-insurance-agent-dashbo.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "855937243489",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:855937243489:web:42ba2cb06b5ee2bf5b8d20"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
